
import { AppMenuService } from '@/services/appmenu.service'

const state = {
    dialog: false,
    loading: false,
    show: false,
    type: null,
    message: null,
    dialogutama: false,
    colordialog: 'indigo',
    totaldata:0,
    totalpage:0,
    judul: '',
    color: '',
    list: [],
    options:{}
};


const actions = {
    OpenDialogForm({ commit }) {
        commit('opendialog');
    },
    closeDialog({ commit }) {
        commit('closedialog');
    },
    list({ commit },opsi) {
        console.log(opsi);
        commit('setloading', true);
        commit('clearList');
        AppMenuService.list(opsi).then(data => {
            commit('addResponseApp', data);
        }, error => {
            console.log(error);
        });
    },
    Delete({ dispatch, commit }, delete_id) {
        AppMenuService.hapus(delete_id).then(data => {
            dispatch('alert/success', 'Delete data Successfully', { root: true });
            commit('ShowAdd', data);
        }, error => {
            dispatch('alert/error', error, { root: true });
        })
    },
    Add({ dispatch, commit }, newData) {
        commit('setloading', true);
        AppMenuService.add(newData)
            .then(data => {
                dispatch('alert/success', 'Add data Successfully', { root: true });
                commit('ShowAdd', data);
                AppMenuService.list().then(data => {
                    //console.log(data.data[0]);
                    commit('addResponseApp', data);
                }, error => {
                    console.log(error);
                });
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
    Edit({ dispatch, commit }, editdata) {
        AppMenuService.edit(editdata)
            .then(data => {
                dispatch('alert/success', 'Edit data Successfully', { root: true });
                commit('ShowAdd', data);
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    }
}


const mutations = {
    clearList(state){
        state.list= []
    },
    ShowAdd(state, data) {
        console.log(data);
        state.dialog = false;
        state.loading = false;
    },
    setloading(state, data) {
        state.loading = data;
    },
    addResponseApp(state, apps) {
        state.list = []
        state.list = apps.data.content;
        state.totaldata=apps.data.totalElements;
        state.totalpage=apps.data.totalPages;
        state.loading = false;
    },
    opendialog(state) {
        state.dialog = true
    },
    closedialog(state) {
        state.dialog = false
    }
}


export const Appmenu = {
    namespaced: true,
    state,
    actions,
    mutations
};
